import { ga } from 'js/analytics/adapters'

export const trackAccountFlowDropOff = ({
  step,
  scenario = '',
  couponCode = '',
  planDuration = null,
  entryPoint = '',
  timeSpentSeconds = 0,
}) => {
  ga.track('account_flow_drop_off', {
    step: step,
    scenario: scenario,
    coupon_code: couponCode,
    plan_duration: planDuration,
    entry_point: entryPoint,
    time_spent_seconds: timeSpentSeconds,
  })
}
